<script>
  import { modals, buy_modal_initiator, pro_yearly_sale_details, user } from '../stores'
  import Button from '../elements/Button.svelte'

  export let feature

  function openBuy() {
    $buy_modal_initiator = feature
    modals.open('buy')

    if (typeof window.gtag == "undefined") return
    gtag('event', 'buy_modal_shown', {
      'initiator': feature
    });
  }
</script>

<Button kind="accent" sale_badge={!!$pro_yearly_sale_details} on:click={openBuy}>
  <slot></slot>
</Button> 